<template>
  <div class="card shadow-sm border-0">
    <div class="card-header bg-white d-flex justify-content-between align-items-center">
      <h5 class="mb-0 text-primary">Supplier Statement</h5>
      <div>
        <!-- <button @click="exportPDF" class="btn btn-outline-danger btn-sm mr-2">
          <i class="fa fa-file-pdf"></i> PDF
        </button>
        <button @click="exportExcel" class="btn btn-outline-success btn-sm">
          <i class="fa fa-file-excel"></i> Excel
        </button> -->
      </div>
    </div>
    <div class="card-body">
      <div class="form-row mb-3">
        <div class="col-md-4">
          <label>Supplier</label>
          <select v-model="filters.supplier_id" class="form-control" @change="fetchStatement">
            <option value="">Select Supplier</option>
            <option v-for="supplier in suppliers" :key="supplier.id" :value="supplier.id">
              {{ supplier.name }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <label>From</label>
          <input type="date" v-model="filters.from" class="form-control" @change="fetchStatement">
        </div>
        <div class="col-md-3">
          <label>To</label>
          <input type="date" v-model="filters.to" class="form-control" @change="fetchStatement">
        </div>
      </div>

      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary"></div>
      </div>

      <div v-else>

        <div class="table-responsive">
          <table class="table table-sm table-hover">
            <thead class="thead-light">
              <tr>
                <th>Date</th>
                <th>Reference</th>
                <th>Description</th>
                <th class="text-right">Debit</th>
                <th class="text-right">Credit</th>
                <th class="text-right">Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(txn, index) in supplierStatement.transactions" :key="index">
                <td>{{ formatDate(txn.date) }}</td>
                <td>{{ txn.reference }}</td>
                <td>{{ txn.description }}</td>
                <td class="text-right" v-if="txn.debit">{{ txn.debit }}</td>
                <td class="text-right" v-else></td>
                <td class="text-right" v-if="txn.credit">{{ txn.credit }}</td>
                <td class="text-right" v-else></td>
                <td class="text-right">{{ txn.balance }}</td>
              </tr>
              <tr class="font-weight-bold bg-light">
                <td colspan="5" class="text-right">Closing Balance</td>
                <td class="text-right">{{ supplierStatement.closing_balance }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="supplierStatement.transactions.length === 0" class="text-center text-muted">
          No supplierStatement.transactions found for selected period.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      suppliers: [],
      supplierStatement: null,
      filters: {
        supplier_id: '',
        from: '',
        to: ''
      },
      loading: false
    };
  },
  computed: {
    // closingBalance() {
    //   if (this.supplierStatement.transactions.length) {
    //     console.log()
    //     return this.supplierStatement.transactions[this.supplierStatement.transactions.length - 1].balance;
    //   }
    //   return '0.00';
    // },

    supplierId() {
        const params = new URLSearchParams(window.location.search);
        return params.get('id');
    }

  },
  methods: {
    fetchSuppliers() {
      axios.get('/api/reports/suppliers')
        .then(res => {
          this.suppliers = res.data;
        });
    },
    fetchStatement() {
        let supplier_id = this.supplierId
      if (this.filters.supplier_id)
      {
        supplier_id = this.filters.supplier_id
      }
      this.loading = true;
      axios.get('/api/suppliers/statement', { params: {supplier_id :supplier_id} })
        .then(res => {
          this.supplierStatement = res.data;

        })
        .finally(() => this.loading = false);
    },
    async downloadPDF() {
      window.open(`/api/suppliers/statement/pdf?supplier_id=${this.filters.supplier_id}&from=${this.filters.from}&to=${this.filters.to}`);
    },
    async downloadExcel() {
      window.open(`/api/suppliers/statement/excel?supplier_id=${this.filters.supplier_id}&from=${this.filters.from}&to=${this.filters.to}`);
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },

    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  mounted() {
    this.fetchSuppliers()
    if(this.supplierId)
  {
    this.fetchStatement()
  }else{
    console.log(this.supplierId,"heeey")
  }
  }
};
</script>
